// src/components/discounts/FinancialAidForm.jsx
import React, { useState } from 'react';

const FinancialAidForm = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [context, setContext] = useState('');
  const [submissionStatus, setSubmissionStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmissionStatus('submitting');

    // In a real application, you would send this data to your backend
    // for review.
    console.log('Financial Aid Request:', { name, email, context });

    // Simulate a successful submission
    setTimeout(() => {
      setName('');
      setEmail('');
      setContext('');
      setSubmissionStatus('success');
    }, 1500);
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h3 className="text-xl font-semibold text-gray-700 mb-4">Request Financial Aid</h3>
      <p className="text-gray-600 mb-4">Share your context with us to explore potential additional discounts.</p>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="name" className="block text-gray-700 text-sm font-bold mb-2">
            Name:
          </label>
          <input
            type="text"
            id="name"
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="email" className="block text-gray-700 text-sm font-bold mb-2">
            Email:
          </label>
          <input
            type="email"
            id="email"
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="context" className="block text-gray-700 text-sm font-bold mb-2">
            Your Context:
          </label>
          <textarea
            id="context"
            rows="4"
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            value={context}
            onChange={(e) => setContext(e.target.value)}
            required
          ></textarea>
          <p className="text-gray-500 text-xs italic mt-1">Please provide details about your situation.</p>
        </div>
        <button
          type="submit"
          className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition duration-300"
          disabled={submissionStatus === 'submitting'}
        >
          {submissionStatus === 'submitting' ? 'Submitting...' : 'Request Aid'}
        </button>
        {submissionStatus === 'success' && (
          <p className="text-green-500 mt-2">Your request has been submitted. We will get back to you soon.</p>
        )}
        {submissionStatus === 'error' && (
          <p className="text-red-500 mt-2">There was an error submitting your request.</p>
        )}
      </form>
    </div>
  );
};

export default FinancialAidForm;